import { Stack } from '@mui/material';
import { FC, useState } from 'react';
import {
  EmptyTeamsAndUsersIcon,
  Item,
  Notification,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import CreateTeamButton from './CreateTeamButton';

const TeamsEmptyList: FC<{ teamCreationAllowed: boolean; isOrganizationalUnit?: boolean }> = ({
  teamCreationAllowed,
  isOrganizationalUnit,
}) => {
  const [createTeamSuccess, setCreateTeamSuccess] = useState<boolean>(false);

  const successHandler = () => setCreateTeamSuccess(true);

  return (
    <>
      <Item sx={{ backgroundColor: 'White', height: '505px' }}>
        <Stack alignItems="center" spacing={3}>
          <EmptyTeamsAndUsersIcon />
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Its lonely here</WsTypography>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>
            {teamCreationAllowed
              ? 'Add teams to your workspace.'
              : 'Ask the workspace owner to add you to their team.'}
          </WsTypography>
          {isOrganizationalUnit && teamCreationAllowed && (
            <CreateTeamButton onEditSuccess={successHandler} onCreateSuccess={successHandler} />
          )}
        </Stack>
      </Item>
      {createTeamSuccess && (
        <Notification
          vertical="top"
          horizontal="center"
          autoHideDuration={3000}
          notificationObject={{
            message: 'Team created successfully!',
            type: 'success',
          }}
          notify={true}
        />
      )}
    </>
  );
};

export default TeamsEmptyList;
